import script from "./MyView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyView.vue?vue&type=script&setup=true&lang=js"

import "./MyView.vue?vue&type=style&index=0&id=a34f6964&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a34f6964"]])

export default __exports__